<ep-view [model]="viewModel">
  <h3>{{appStrings.aboutDesc}}</h3>
</ep-view>